import { ComponentChildren } from 'preact';
import { baseStyles, userSelectStyles } from './themes/VisStatusMessageStyles.css';
import { HTMLAttributesSignalExcluded } from '../utils/UNSAFE_attributeUtils';
import { Flex } from '../UNSAFE_Flex';
import { classNames } from '../utils/UNSAFE_classNames';

export type Props = {
  /**
   * The children to put in the grid.
   */
  children: ComponentChildren;
  isSelectable?: false;
  id?: string;
  'aria-label'?: HTMLAttributesSignalExcluded['aria-label'];
  'aria-describedby'?: HTMLAttributesSignalExcluded['aria-describedby'];
  'aria-labelledby'?: HTMLAttributesSignalExcluded['aria-labelledby'];
};

export function VisStatusMessage({ children, ...otherProps }: Props) {
  const itemClasses = classNames([otherProps.isSelectable ? '' : userSelectStyles, baseStyles]);

  return (
    <div
      class={itemClasses}
      tabIndex={0}
      role="application"
      id={otherProps.id}
      aria-label={otherProps['aria-label']}
      aria-describedby={otherProps['aria-describedby']}
      aria-labelledby={otherProps['aria-labelledby']}>
      <Flex width="100%" height="100%" justify="center" align="center">
        {children}
      </Flex>
    </div>
  );
}
